import { useMemo } from "react";
import { ListFormatter, TextFormatter } from "../muiTableHelper";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { _SITE_TYPES } from "../../constants";
import { is } from "../../function";
import { getEntityProperties } from "../../formHelper";

export const SitesListColumns = ({ setEditData, setShowModal }) => {
  return useMemo(
    () => [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.name,
          });
        },
      },
      {
        accessorKey: "type",
        header: "Type",
        Cell: ({ row }) => {
          const type = is(row.original?.type)
            ? _SITE_TYPES.find((type) => type.value === row.original.type).label
            : "-";
          return TextFormatter({
            text: type,
          });
        },
      },
      {
        accessorKey: "code",
        header: "Code",
        Cell: ({ row }) => {
          return TextFormatter({
            text: row.original.code,
          });
        },
      },
      {
        accessorKey: "activities",
        header: "Activities",
        Cell: ({ row }) => {
          return ListFormatter(
            getEntityProperties(row.original.activities, "name")
          );
        },
      },
      {
        accessorKey: "actions",
        header: "Actions",
        Cell: ({ row }) => {
          return (
            <>
              <IconButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setEditData(row.original);
                  setShowModal(true);
                }}>
                <EditIcon />
              </IconButton>
            </>
          );
        },
      },
    ],
    [setEditData, setShowModal]
  );
};

export default SitesListColumns;
